import React from "react";
import axios from "axios";
import { FcGoogle } from "react-icons/fc";
import "../styles/AuthButton.css";

const LogoutButton: React.FC<{ onLogout: () => void }> = ({ onLogout }) => {
  const handleLogout = async () => {
    const GOOGLE_LOGOUT = process.env.VITE_GOOGLE_LOGOUT!
    await axios.get(GOOGLE_LOGOUT, { withCredentials: true });
    onLogout();
  };

  return (
    <button onClick={handleLogout} style={{ padding: "5px 7px", marginLeft: "10px"}}>
      <FcGoogle style={{ marginRight: "8px", verticalAlign: "middle" }} />
      Logout
    </button>
  );
};

export default LogoutButton;